module.exports = __webpack_public_path__ + "img/Bard.9cdff119.png";